import React, { useEffect } from 'react';
import { Routes as RouterRoutes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom';
import { AUTHENTICATED_ENTRY } from 'configs/AppConfig';
import { authRoutes, protectedRoutes, publicRoutes } from 'configs/RoutesConfig';
import ProtectedRoute from './ProtectedRoute';
import AppRoute from './AppRoute';
import AddUser from 'views/app-views/whatsapp/User/AddUser';
import UserSetting from 'views/app-views/whatsapp/User/setting';
import UserStates from 'views/app-views/whatsapp/UserStates/userState';
import Reports from 'views/app-views/whatsapp/Reports/Reports';
import Templates from 'views/app-views/whatsapp/Template/templates';
import ChatbotByUser from 'views/app-views/whatsapp/ChatBot/chatbotByUser';
import NewChatBot from 'views/app-views/whatsapp/ChatBot/NewChatBot';

import ContactList from 'views/app-views/whatsapp/Contacts/ContactList';
import GroupList from 'views/app-views/whatsapp/Groups/GroupList';
import Role from 'views/app-views/whatsapp/Role/Role';
import RolePermission from 'views/app-views/whatsapp/Role/RolePermission';
import OutReports from 'views/app-views/whatsapp/Reports/OutReports';
import { useMyContext } from 'Context/MyContextProvider';
// import AddTemplate from 'views/app-views/whatsapp/Template/AddTemplate';
import ErrorOne from 'views/auth-views/errors/error-page-1';
import EditChatBot from 'views/app-views/whatsapp/ChatBot/EditChatBot';
import DefaultResponse from 'views/app-views/whatsapp/ChatBot/DefaultResponse';
import ApiKey from 'views/app-views/whatsapp/Developer/ApiKey';
import Logs from 'views/app-views/whatsapp/Logs/Logs';
import ApiDocument from 'views/app-views/whatsapp/Developer/ApiDocument';
import LiveStatus from 'views/app-views/whatsapp/Live Status/LiveStatus';
import CreditHistory from 'views/app-views/whatsapp/CreditHistory/CreditHistory';
import BlockedNumbers from 'views/app-views/whatsapp/BlockedNumbers';
import ScheduleCampaign from 'views/app-views/whatsapp/ScheduleCampaign';
import EmailTemplate from 'views/app-views/whatsapp/EmailTemplate/EmailTemplate';
import LiveChat from 'views/app-views/whatsapp/chat';
import CarouselTemplates from 'views/app-views/whatsapp/Carousel/CarouselTemplates';
import CarouselCampaign from 'views/app-views/whatsapp/Carousel/CarouselCampaign';
import NewPreset from 'views/app-views/whatsapp/Carousel/Preset/NewPreset';
import PresetList from 'views/app-views/whatsapp/Carousel/Preset/PresetList';
import Maintenance from 'views/app-views/whatsapp/Maintenance/Maintenance';
import ErrorCode from 'views/app-views/whatsapp/ErrorCode/Errorcode';
import AdminSetting from 'views/app-views/whatsapp/User/setting/AdminSetting';
import Logout from 'views/app-views/whatsapp/Auth/Logout';
import Campaign from 'views/app-views/whatsapp/Campaign/index';
import UserConfig from 'views/app-views/whatsapp/UserConfig/UserConfig';
import SMSForYouPricing from 'views/app-views/whatsapp/Pricing/Pricing';
import AgentList from 'views/app-views/whatsapp/Support/Agents';
import AssignmentHistory from 'views/app-views/whatsapp/Support/AssignmentHistory';
import Media from 'views/app-views/whatsapp/Media';
import ListMessagePresets from 'views/app-views/whatsapp/ListItem/Components/ListMessagePresets';
import ListMessagePreset from 'views/app-views/whatsapp/ListItem/Components/NewListPreset';
import CleanUp from 'views/app-views/whatsapp/CleanUp/CleanUp';
import FlowGroupList from 'views/app-views/whatsapp/FlowBuilder/FlowGroupList';
import FlowList from 'views/app-views/whatsapp/FlowBuilder/FlowList';
import FlowEditor from 'views/app-views/whatsapp/FlowBuilder/FlowEditor';
import PricingManagement from 'views/app-views/whatsapp/Pricing/PricingManagement';
import GlobalReports from 'views/app-views/whatsapp/Reports/GlobalReports';
import CarouselTemplateCreator from 'views/app-views/whatsapp/Carousel/New/CarouselTemplateCreator';
import NewFlow from 'views/app-views/whatsapp/Flows/NewFlow';
import MetaFlowCreate from 'views/app-views/whatsapp/Flows/MetaFlowCreate';
import FlowsFlowList from 'views/app-views/whatsapp/Flows/FlowList';
import MetaFlowResponses from 'views/app-views/whatsapp/Flows/MetaFlowResponses';
import MetaFlowLeads from 'views/app-views/whatsapp/Flows/MetaFlowLeads';
import MetaFlowHook from 'views/app-views/whatsapp/Flows/MetaFlowHook';
import PaymentGateway from 'views/app-views/whatsapp/PaymentGateway/PaymentGateway';
import AuthRoute from './AuthRoute';
import NewTemplate from 'views/app-views/whatsapp/Template/NewTemplate';
import ManageApiKeys from 'views/app-views/whatsapp/SystemSettings/ManageApiKeys';
import MaintenanceConfig from 'views/app-views/whatsapp/User/setting/MaintenanceConfig';
import KeywordRestriction from 'views/app-views/whatsapp/SystemSettings/KeywordRestriction';
import MetaPricing from 'views/app-views/whatsapp/SystemSettings/MetaPricing';
import MetaFlowConfig from 'views/app-views/whatsapp/SystemSettings/MetaFlowConfig';
import ApiTesting from 'views/app-views/whatsapp/SystemSettings/ApiTesting';



const Routes = () => {
	const { UserCredits, isMainServer, authToken } = useMyContext();
	const navigate = useNavigate();
	const location = useLocation();
	useEffect(() => {
		UserCredits();
	}, []);

	// make useEffect if there in not route then redirect to home
	useEffect(() => {
		// if there is no route, redirect to home means panel.com or any site.com 
		if (location.pathname === '/' || location.pathname === '') {
			if (isMainServer) {
				navigate('/home');
			} else {
				navigate(authToken ? AUTHENTICATED_ENTRY : '/login');
			}
		}

	}, [authToken, navigate, isMainServer, location]);

	return (
		<RouterRoutes>
			{/* Public home route always available */}

			{/* Auth routes for unauthenticated users */}
			<Route path="/" element={<AuthRoute />}>
				{authRoutes.map(route => (
					<Route
						key={route.key}
						path={route.path}
						element={<AppRoute routeKey={route.key} component={route.component} {...route.meta} />}
					/>
				))}
			</Route>

			{/* Protected routes for authenticated users */}
			<Route path="/" element={<ProtectedRoute />}>
				<Route path="/" element={<Navigate replace to={AUTHENTICATED_ENTRY} />} />
				{protectedRoutes.map((route, index) => (
					<Route
						key={route.key + index}
						path={route.path}
						element={<AppRoute routeKey={route.key} component={route.component} {...route.meta} />}
					/>
				))}
				{/* ...existing custom protected routes... */}
				<Route path="users">
					<Route path="add" element={<AddUser />} />
					<Route path="manage/:id/*" element={<UserSetting />} />
				</Route>
				{/* <Route path="*" element={<Navigate to="/" replace />} /> */}
				<Route path="maintenance" element={<Maintenance />} />
				<Route path="error-codes" element={<ErrorCode />} />
				<Route path="keyword-restriction" element={<KeywordRestriction />} />
				<Route path="meta-pricing" element={<MetaPricing />} />
				<Route path="meta-flow-config" element={<MetaFlowConfig />} />
				<Route path="api-testing" element={<ApiTesting />} />
				<Route path="setting" element={<AdminSetting />} />
				<Route path="logout" element={<Logout />} />
				<Route path="re-target-campaign" element={<Campaign isReTarget={true} />} />
				<Route path="users-config" element={<UserConfig />} />
				<Route path="support-agents" element={<AgentList />} />
				<Route path="assignment-history" element={<AssignmentHistory />} />
				<Route path="pricing" element={<SMSForYouPricing />} />
				<Route path="manage-plans" element={<PricingManagement />} />
				<Route path="analytics" element={<UserStates />} />
				<Route path="404" element={<ErrorOne />} />
				<Route path="incoming-reports" element={<Reports />} />
				<Route path="out-reports" element={<OutReports />} />
				<Route path="template" element={<Templates />} />
				<Route path="/default-response" element={<DefaultResponse />} />
				<Route path="template">
					{/* <Route path="add"  element={<AddTemplate />} /> */}
					<Route path="add" element={<NewTemplate />} />
				</Route>
				<Route path="groups" element={<GroupList />} />
				<Route path="groups">
					<Route path="manage/:id" element={<ContactList />} />
				</Route>
				<Route path="roles" element={<Role />} />
				<Route path="roles">
					<Route path="permission/:id/:role_name" element={<RolePermission />} />
				</Route>
				<Route path="carousel">
					<Route path="campaign" element={<CarouselCampaign />} />
					<Route path="re-target-campaign" element={<CarouselCampaign isReTarget={true} />} />
					<Route path="preset" element={<PresetList />} />
					<Route path="preset">
						<Route path="add" element={<NewPreset />} />
					</Route>
					<Route path="template" element={<CarouselTemplates />} />
					<Route path="template">
						{/* <Route path="add"  element={<NewCarouselTemplate />} /> */}
						<Route path="add" element={<CarouselTemplateCreator />} />
					</Route>
				</Route>
				<Route path="media" element={<Media />} />
				<Route path="api-key" element={<ApiKey />} />
				<Route path="api-doc" element={<ApiDocument />} />
				<Route path="/intimations" element={<MaintenanceConfig />} />
				<Route path="/log" element={<Logs />} />
				<Route path="/live-status" element={<LiveStatus />} />
				<Route path="/credit-history" element={<CreditHistory />} />
				<Route path="/global-reports" element={<GlobalReports />} />
				<Route path="/block-number" element={<BlockedNumbers />} />
				<Route path="/schedule-campaign" element={<ScheduleCampaign />} />
				<Route path="/email-template" element={<EmailTemplate />} />
				<Route path="/chats/*" element={<LiveChat />} />
				<Route path="/list-item" element={<ListMessagePresets />} />
				<Route path="list-item">
					<Route path="edit" element={<ListMessagePreset />} />
					<Route path="add" element={<ListMessagePreset />} />
				</Route>
				<Route path="/chatbot-flows" element={<FlowGroupList />} />
				<Route path="chatbot-flows">
					<Route path=":groupId/:name" element={<FlowList />} />
					<Route path=":groupId/:name/editor/:flowId" element={<FlowEditor />} />
				</Route>
				<Route path="manage-request">
					<Route path=":GroupId/:name" element={<ChatbotByUser />} />
					<Route path=":GroupId/:name">
						<Route path="add/:id" element={<NewChatBot />} />
						<Route path="edit/:userid/:id" element={<EditChatBot />} />					</Route>
				</Route>
				<Route path="/manage-api-keys" element={<ManageApiKeys />} />
				<Route path="/clean-up" element={<CleanUp />} />
				<Route path="flows" element={<FlowsFlowList />} />
				<Route path="flow-responses" element={<MetaFlowResponses />} />
				<Route path="flow-leads" element={<MetaFlowLeads />} />
				<Route path="flow-hook" element={<MetaFlowHook />} />
				<Route path="/flows">
					<Route path="create-flow" element={<MetaFlowCreate />} />
					<Route path="edit/:flowId" element={<NewFlow />} />
				</Route>

				<Route path="payment-gateway/*" element={<PaymentGateway />} />
			</Route>

			{/* Public routes - accessible to everyone when isMainServer is true */}
			{isMainServer && publicRoutes.map(route => (
				<Route
					key={route.key}
					path={route.path}
					element={<AppRoute routeKey={route.key} component={route.component} {...route.meta} />}
				/>
			))}
			{/* Fallback routes */}
			<Route path="*" element={
				<Navigate
					to={
						isMainServer
							? "/home"  // Always redirect to home on main server
							: (authToken ? AUTHENTICATED_ENTRY : "/login") // On other servers, redirect based on auth
					}
					replace
				/>
			} />
		</RouterRoutes>
	)
}

export default Routes